/** @format */

export function loadSisCommonTranslations(lang: string): Promise<any> {
    switch (lang) {
        case 'fi':
            return import('./fi.json');
        case 'sv':
            return import('./sv.json');
        case 'en':
            return import('./en.json');
        default:
            throw new Error(`Unsupported language: ${lang}`);
    }
}
